<template>
    <ProgressDialog :loading="!dataLoaded" loadingText="Preparing dashboard editor.." />
    <div v-if="dataLoaded">
        <splitpanes class="default-theme" style="height: 100vh;">
            <pane :style="{ height: '100%', overflow: 'auto' }">
                <DashboardEditor />
            </pane>
            <pane>
                <div class="preview-container">
                    <DashboardView :isPreview="true" />
                </div>
            </pane>
        </splitpanes>
    </div>
</template>


<script>
import DashboardView from '@views/DashboardView.vue'
import 'splitpanes/dist/splitpanes.css'
import { Splitpanes, Pane } from 'splitpanes'
import DashboardEditor from '@components/DashboardEditor.vue'
import ProgressDialog from '@components/ui/ProgressDialog.vue'


export default {
    name: 'EditorView',
    inject: ['dashboardState'],
    components: {
        DashboardView,
        Splitpanes,
        Pane,
        DashboardEditor,
        ProgressDialog
    },
    data() {
        return {
            dataLoaded: false
        }
    },
    methods: {
    },
    mounted() {
        this.dashboardState.loadDashboard(this.$route.params.id, true).then(() => {
            this.dataLoaded = true
        })
    }

}
</script>

<style lang="scss" scoped>
.preview-container {
    /* 16:9 aspect ratio */
    padding-top: 56.25%;
    position: relative;
    overflow: auto;
}

.preview-container>* {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
